/**
 * Tipos de reunião — o catálogo que o legado tinha (`erp_tipo_reuniao`) e a
 * Onda 2 trocou por um enum de três valores.
 *
 * A volta do catálogo não traz de volta o defeito: as duas exigências são
 * caixas de seleção nesta tela, e nada no sistema olha para o nome do tipo.
 */

import { MeetingType, meetingTypesApi, queryKeys } from '@/lib/api';
import {
  SupportTypeAdmin,
  type SupportTypeFlag,
} from '@/components/sgq/support-type-admin';

const FLAGS: readonly SupportTypeFlag<MeetingType>[] = [
  {
    key: 'requiresNonconformity',
    label: 'Exige não-conformidade',
    description:
      'A reunião só pode ser agendada e encerrada com ao menos uma não-conformidade vinculada.',
  },
  {
    key: 'requiresEffectiveness',
    label: 'Exige avaliação de eficácia',
    description:
      'Depois de encerrada, a reunião fica aguardando a avaliação de eficácia — ISO 13485 §8.5.2.',
  },
];

export function MeetingTypesPage() {
  return (
    <SupportTypeAdmin<MeetingType>
      title="Tipos de reunião"
      description="Cada tipo define o que a reunião vai exigir. As regras vêm das opções abaixo, nunca do nome — renomear um tipo não muda nada do que ele exige."
      noun="tipo de reunião"
      usageNoun="reunião"
      breadcrumbLabel="Tipos de reunião"
      queryKey={queryKeys.meetingTypes.all({ includeInactive: true })}
      flags={FLAGS}
      api={meetingTypesApi as never}
    />
  );
}
